import { IUserNotification } from '@tableau/user-notifications-client-core';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';

export interface IGetUserNotificationsParams extends IGetItemsParams {
}

export interface IGetUserNotificationsResult extends IGetItemsResult {
  userNotifications: IUserNotification<any>[];
}

export class GetUserNotificationsRequest extends Request<IGetUserNotificationsParams, IGetUserNotificationsResult> {
  constructor(params: IGetUserNotificationsParams = {}) {
    super('getUserNotifications', params);
  }
}